
import Menu from "./menu";
import extractOptions from "../../utility/extractOptions";

export function applyToElement(element) {

    if(!window.document.menu){

        const options = Object.assign(
            {},
            Menu.DEFAULTS,
            extractOptions("menu", element)
        );
        const instance = new Menu(element, options);
        
        window.document.menu = instance;
    }
}


// WEBPACK FOOTER //
// ./project/client/src/core/components/menu/index.js